import PaymentInformation from './PaymentInformation';

export default PaymentInformation;
